import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(categoriesStyles, {
    container: {
        gap: 5,
        css: css`
            margin: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    title: {
        variant: "h2",
        transform: "inherit",
        css: css`
            text-transform: uppercase;
            margin-bottom: 1.2em;
        `,
    },
    innerCategoryContainer: {
        gap: 1,
        css: css`
            width: 100%;
            padding: 6px 8px;
            border: 1px solid rgb(230, 230, 230);
            height: 100%;
            div {
                text-align: center;
                justify-content: center;
                font-size: 14px;
            }
            & :hover {
                box-shadow: rgb(0 0 0 / 4%) 0px 10px 10px;
            }
        `,
    },
    categoryImageItem: {
        width: 12,
        align: "middle",
        css: css`
            width: 100%;
            justify-content: center;
            > a {
                height: 115px;
                > span,
                img {
                    height: inherit;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            > a {
                                height: 140px;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    categoryNameLinkItem: {
        width: 12,
        css: css`
            justify-content: center;
            align-self: center;
            // padding-left: 10px;
            font-size: ${TYPOGRAPHY.size.smaller};
            a {
                span {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${TYPOGRAPHY.size.tiny};
                        `,
                    ],
                    "max",
                )}
        `,
    },
    categoryContainer: {
        gap: 20,
    },
    categoryItemRow: {
        width: [6, 6, 4, 4, 4],
    },
});
